import { AddCircle } from "@mui/icons-material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Dialog, IconButton, Switch, Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { DialogTitle } from "common";
import I18n from "i18n-js";
import DataCard from "../../components/DataCard/DataCard";
import { CardSettings } from "../../components/DataCard/useDataCard";
import useWaiverList, { WaiverListContext } from "./useWaiverList";
import { WaiverStatus } from "./waiverApi";
import WaiverCreateDialog from "./WaiverCreateDialog";
import WaiverPreview from "./WaiverPreview";

export default function WaiverList() {
  const context = useWaiverList();
  const {
    setCreateSelectorOpen,
    createSelecterDialog,
    previewDialog,
    previewItem,
    handlePreviewOpen,
    handleCopy,
    handleStatusChange,
    grid,
    waiverLimit,
    waiverCount,
    canAddWaiver,
  } = context;
  const cardSettings: CardSettings = {
    header: {
      titleField: "name",
    },
    body: row => (
      <Box
        sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 10 }}
      >
        lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum.
      </Box>
    ),
  };

  return (
    <WaiverListContext.Provider value={context}>
      {/*<PageHeader avatar={<NoteAltIcon />} title={I18n.t("Waiver.title")} />*/}
      <DataCard
        {...grid}
        canEdit
        canDelete
        editUrl=":id/edit"
        headerTitle={
          <>
            <NoteAltIcon />
            <Typography variant="h5">{I18n.t("Waiver.title")}</Typography>
          </>
        }
        renderCreateButton={create => (
          <IconButton
            title={I18n.t("Waiver.addTitle")}
            onClick={() => {
              setCreateSelectorOpen(true);
            }}
            // disabled={!canAddWaiver}
          >
            <AddCircle />
          </IconButton>
        )}
        cardHeaderAction={params => (
          <Box sx={{ position: "relative" }}>
            <Switch
              color="success"
              checked={(() => {
                return params.row.status === WaiverStatus.ACTIVE;
              })()}
              onChange={async (event, checked) => {
                handleStatusChange(
                  params.row.id,
                  checked ? WaiverStatus.ACTIVE : WaiverStatus.INACTIVE
                );
              }}
              sx={{ ml: "auto" }}
            />
            <Typography
              variant="caption"
              sx={{ position: "absolute", top: -8, right: 10, zIndex: 100 }}
            >
              {params.row.status_label}
            </Typography>
          </Box>
        )}
        headerItems={["search", "refresh"]}
        cardSettings={cardSettings}
        cardActions={(params: any) => [
          <GridActionsCellItem
            icon={<VisibilityIcon />}
            label={I18n.t("Waiver.preview")}
            title={I18n.t("Waiver.preview")}
            onClick={() => {
              handlePreviewOpen(params.id);
            }}
          />,
          <GridActionsCellItem
            icon={<ContentCopyIcon />}
            label={I18n.t("Waiver.copy")}
            title={I18n.t("Waiver.copy")}
            onClick={() => {
              handleCopy(params.id);
            }}
          />,
        ]}
        canCreate //={canAddWaiver}
      />
      <Dialog {...createSelecterDialog} fullWidth>
        <WaiverCreateDialog onClose={createSelecterDialog.onClose} />
      </Dialog>
      <Dialog {...previewDialog} maxWidth="xl">
        <DialogTitle onClose={previewDialog.onClose}>Preview</DialogTitle>
        {previewItem && <WaiverPreview item={previewItem} />}
      </Dialog>
    </WaiverListContext.Provider>
  );
}
